import { render, staticRenderFns } from "./StudentInvoiceCreate.vue?vue&type=template&id=328be63c&"
import script from "./StudentInvoiceCreate.vue?vue&type=script&lang=js&"
export * from "./StudentInvoiceCreate.vue?vue&type=script&lang=js&"
import style0 from "./StudentInvoiceCreate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports